import { render, staticRenderFns } from "./grossing-touch-sample-tab-media.vue?vue&type=template&id=d6f7200a&scoped=true&"
import script from "./grossing-touch-sample-tab-media.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-sample-tab-media.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-sample-tab-media.scss?vue&type=style&index=0&id=d6f7200a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f7200a",
  null
  
)

export default component.exports